import { integrationPlugin } from '@vue-storefront/core';

export default integrationPlugin(({ integration }) => {
  integration.configure('adyen', { ...{"availablePaymentMethods":["scheme","paypal","klarna_account","ratepay","onlineBanking_PL","ideal","klarna","klarna_b2b","applepay","googlepay","multibanco","twint","mobilepay"],"clientKey":"live_FS3MLK77NND5TM6ZAKOVOJOQIADJU57A","environment":"live","methods":{"paypal":{"merchantId":"PN3DG2BHU74LQ","intent":"capture"}}} });
});
